import { module } from 'angular';
import { padStart, isNil } from 'lodash';
import { IMoniker } from './IMoniker';

export interface IComponentName {
  application: string;
  stack: string;
  freeFormDetails: string;
  cluster: string;
}

export class NamingService {
  public static VERSION_PATTERN: RegExp = /(v\d{3})/;

  public parseServerGroupName(serverGroupName: string): IComponentName {
    const result: IComponentName = {
      application: '',
      stack: '',
      freeFormDetails: '',
      cluster: '',
    };

    if (!serverGroupName) {
      return result;
    }
    const split: string[] = serverGroupName.split('-'),
          isVersioned = NamingService.VERSION_PATTERN.test(split[split.length - 1]);

    result.application = split[0];

    if (isVersioned) {
      split.pop();
    }

    if (split.length > 1) {
      result.stack = split[1];
    }
    if (split.length > 2) {
      result.freeFormDetails = split.slice(2, split.length).join('-');
    }
    result.cluster = this.getClusterNameFromServerGroupName(serverGroupName);

    return result;
  }

  public parseClusterName(clusterName: string): IComponentName {
    return this.parseServerGroupName(clusterName);
  }

  public getClusterName(app: string, stack: string, detail: string): string {
    let clusterName = app;
    if (stack) {
      clusterName += `-${stack}`;
    }
    if (!stack && detail) {
      clusterName += `-`;
    }
    if (detail) {
      clusterName += `-${detail}`;
    }
    return clusterName;
  }

  public getClusterNameFromServerGroupName(serverGroupName: string): string {
    const split = serverGroupName.split('-'),
      isVersioned = NamingService.VERSION_PATTERN.test(split[split.length - 1]);

    if (isVersioned) {
      split.pop();
    }
    return split.join('-');
  }

  public getSequence(monikerSequence: number): string {
    if (isNil(monikerSequence)) {
      return 'N/A';
    } else {
      return `v${padStart(monikerSequence.toString(), 3, '0')}`;
    }
  }

  public parseLoadBalancerName(loadBalancerName: string): IComponentName {
    const split = loadBalancerName.split('-'),
      result: IComponentName = {
        application: split[0],
        stack: '',
        freeFormDetails: '',
        cluster: '',
      };

    if (split.length > 1) {
      result.stack = split[1];
    }
    if (split.length > 2) {
      result.freeFormDetails = split.slice(2, split.length).join('-');
    }
    result.cluster = this.getClusterName(result.application, result.stack, result.freeFormDetails);
    return result;
  }

  public parseSecurityGroupName(securityGroupName: string): IComponentName {
    return this.parseLoadBalancerName(securityGroupName);
  }

  public getMoniker(app: string, stack: string, detail: string): IMoniker {
    return { app, stack, detail };
  }
}

export const NAMING_SERVICE = 'spinnaker.core.naming.service';

module(NAMING_SERVICE, [])
  .service('namingService', NamingService);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/naming/naming.service.ts